import { call, fork, put } from 'redux-saga/effects'
import firebase from '../config/firebase'

import PickUpPromotionActions from '../reducers/pickUpPromotionReducer'

export function* getPickUpPromotions() {
  try {
    const dbRef = firebase.firestore().collection('pick_up_discount_promotions')

    const snapshot = yield call([dbRef, dbRef.get])
    const promotions = {}

    snapshot.forEach(doc => {
      promotions[doc.id] = { ...doc.data(), key: doc.id }
    })

    yield put(PickUpPromotionActions.setPickUpPromotion(promotions))
    yield put(PickUpPromotionActions.setPickUpPromotionLoading(false))
  } catch (error) {
    yield put(PickUpPromotionActions.setPickUpPromotionLoading(false))
  }

  yield put(PickUpPromotionActions.setPickUpPromotionLoading(true))
}

export function* deletePickUpPromotion({ promotionId }) {
  const dataRef = firebase
    .firestore()
    .collection('pick_up_discount_promotions')
    .doc(promotionId)

  try {
    yield fork([dataRef, dataRef.delete])
  } catch (err) {
    alert(err)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/pickUpPromotionSaga.js